import { api } from 'api';
import { useApiCall } from '../useApiCall';
export var useGetFeatureFlags = function () {
    return useApiCall(function (signal) { return api.tenant.apiTenantGetFeatureFlagsGet({ signal: signal }); }, null, true, []);
};
